import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { LargeOnly, Table, Thead, Th } from "commons";

import { TrxTr } from "./styled/TrxTr";
import { IHTr } from "./styled/IHTr";

export class TransactionTableDisplay extends PureComponent {
    renderIncomeHistoryTable = () => {
        const isCp = this.props.isClientPortal;
        return (
            <PrintDisplayedTable isClientPortal={isCp}>
                <TrxTable id="table" isClientPortal={isCp}>
                    <TrxThead isClientPortal={isCp}>
                        <IHHeadTrxTr isClientPortal={isCp} isIncomeHistory={true}>
                            <TrxTh isClientPortal={isCp} width="25%" align="left">
                                Effective date
                            </TrxTh>
                            <TrxTh isClientPortal={isCp} width="55%" align="left">
                                Description
                            </TrxTh>
                            <TrxTh isClientPortal={isCp} width="20%">
                                Amount
                            </TrxTh>
                        </IHHeadTrxTr>
                    </TrxThead>
                    <TrxTbody data-testid="income-history-table-body" isClientPortal={isCp}>
                        {this.props.rows}
                    </TrxTbody>
                </TrxTable>
            </PrintDisplayedTable>
        );
    };

    renderTransactionsTable = () => {
        const isCp = this.props.isClientPortal;
        return (
            <PrintDisplayedTable isClientPortal={isCp}>
                <TrxTable id="table" isClientPortal={isCp}>
                    <TrxThead isClientPortal={isCp}>
                        <HeadTrxTr
                            data-testid="transactions-table-header-row"
                            isClientPortal={isCp}
                        >
                            <TrxTh isClientPortal={isCp} width="8%" align="left">
                                Effective <br />
                                date
                            </TrxTh>
                            <TrxTh isClientPortal={isCp} width="8%" align="left">
                                Processed <br />
                                date
                            </TrxTh>
                            <TrxTh isClientPortal={isCp} width="8%" align="left">
                                Reporting <br />
                                date
                            </TrxTh>
                            <TrxTh isClientPortal={isCp} width="29%" align="left">
                                Description
                            </TrxTh>
                            <TrxTh isClientPortal={isCp} width="10%">
                                Units
                            </TrxTh>
                            <TrxTh isClientPortal={isCp} width="8%">
                                Price
                            </TrxTh>
                            <TrxTh isClientPortal={isCp} width="9%">
                                Fees
                            </TrxTh>
                            <TrxTh isClientPortal={isCp} width="10%">
                                Amount
                            </TrxTh>
                            <TrxTh isClientPortal={isCp} width="10%">
                                Cash
                                <br /> balance
                            </TrxTh>
                            {this.props.isClientPortal && (
                                <LargeOnly enabled={isCp}>
                                    <TrxTh />
                                </LargeOnly>
                            )}
                        </HeadTrxTr>
                    </TrxThead>
                    <TrxTbody data-testid="transactions-table-body" isClientPortal={isCp}>
                        {this.props.rows}
                    </TrxTbody>
                </TrxTable>
            </PrintDisplayedTable>
        );
    };

    render() {
        return this.props.isIncomeHistory
            ? this.renderIncomeHistoryTable()
            : this.renderTransactionsTable();
    }
}

const TrxTable = styled(Table)`
    ${props =>
        props.isClientPortal &&
        `
    @media only screen and (max-width: ${props.theme.maxWidth}) {
        display: block;
    }`}
`;

const TrxThead = styled(Thead)`
    ${props =>
        props.isClientPortal &&
        `
    @media only screen and (max-width: ${props.theme.maxWidth}) {
        display: block;
    }`}
`;

export const TrxTbody = styled.tbody`
    ${props =>
        props.isClientPortal &&
        `
    @media only screen and (max-width: ${props.theme.maxWidth}) {
        display: block;
    }`}
`;

export const TrxTh = styled(Th)`
    ${props =>
        props.isClientPortal &&
        `
    @media only screen and (max-width: ${props.theme.maxWidth}) {
        display: block;
    }`}
`;

const HeadTrxTr = styled(TrxTr)`
    ${props =>
        props.isClientPortal &&
        `
    @media only screen and (max-width: ${props.theme.maxWidth}) {
        position: absolute;
        top: -9999px;
        left: -9999px;
    }`}
`;

const IHHeadTrxTr = styled(IHTr)`
    ${props =>
        props.isClientPortal &&
        `
    @media only screen and (max-width: ${props.theme.maxWidth}) {
        position: absolute;
        top: -9999px;
        left: -9999px;
    }`}
`;

const PrintDisplayedTable = styled.div`
    visibility: visible;
    clear: both;

    ${props =>
        props.isClientPortal &&
        `
    @media only screen and (min-width: ${props.theme.minWidth}) {
        padding: 5px;
        background: white;
    }`}
`;

TransactionTableDisplay.propTypes = {
    isClientPortal: PropTypes.bool,
    isIncomeHistory: PropTypes.bool,
    rows: PropTypes.array
};

TransactionTableDisplay.defaultProps = {
    isIncomeHistory: false
};
